import React, { useState, useEffect, Fragment } from 'react';
import { Transition, Menu } from '@headlessui/react';
import { Link } from 'react-router-dom';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlex } from '../../Assistant/DefaultStyle';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {

      if (document.body.scrollTop >= 0 || document.documentElement.scrollTop >= 0) {
        // document.getElementById("navBar").style.top = "0";
      } else {
        // document.getElementById("navBar").style.top = "-70px";
      }

      // if (window.scrollY > 100) {
      //   const moveBottom = document.querySelector('#nav')
      //   moveBottom.classList.add('animate-bounce-bottom')
      //   }
    });
  }, []);



  return (
    <div>
      <nav className={`fixed bg-textColor left-0 top-0 right-0 z-10`} id="navBar" >
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className={`${DefaultFlex} items-center h-16`}>
            <div className='flex items-center'>
              <div className='flex-shrink-0'>
                <img
                  className='h-10 w-10'
                  src='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/gsteplogo.png?alt=media&token=37873c78-7f7c-4b42-9264-925e069a522b'
                  alt='Workflow'
                />
              </div>
              <div className='hidden md:block'>
                <div className='mr-10 flex items-baseline space-x-4'>

                  <Link to='/' className={`hover:bg-amber hover:text-textColor text-amber px-3 py-2 rounded-md text-lg font-medium`} >الرئيسية</Link>

                  <Link className={`${FontsDefault.contentNav}`} to='/ourServices'>خدماتنا</Link>

                  <Link className={`${FontsDefault.contentNav}`} to='/about'>من نحن</Link>

                  <Link className={`${FontsDefault.contentNav}`} to='/team'>فريق العمل</Link>
                </div>
              </div>
            </div>
            <div className='-mr-2 flex md:hidden'>
              <button
                onClick={() => setIsOpen(!isOpen)}
                type='button'
                className={`bg-gray900 inline-flex items-center justify-center p-2 rounded-md text-gray400 hover:text-textColor hover:bg-gray800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white`}
                aria-controls='mobile-menu'
                aria-expanded='false'
              >
                <span className='sr-only'>Open main menu</span>
                {!isOpen ? (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  </svg>
                ) : (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M6 18L18 6M6 6l12 12'
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter='transition ease-out duration-100 transform'
          enterFrom='opacity-0 scale-95'
          enterTo='opacity-100 scale-100'
          leave='transition ease-in duration-75 transform'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-95'
        >
          {(ref) => (
            <div className='md:hidden' id='mobile-menu'>
              <div ref={ref} className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
                <h1
                  onClick={() => setIsOpen(!isOpen)}
                  className={`hover:bg-gray700 text-amber block px-3 py-2 rounded-md text-base font-medium`}
                >
                  <Link to='/'>الرئيسية</Link>
                </h1>

                <h1
                  onClick={() => setIsOpen(!isOpen)}
                  className={`${FontsDefault.contentNav}`}
                >
                  <Link to='/ourServices'>خدماتنا</Link>
                </h1>

                <h1
                  onClick={() => setIsOpen(!isOpen)}
                  className={`${FontsDefault.contentNav}`}
                >
                  <Link to='/about'>من نحن</Link>
                </h1>

                <h1
                  onClick={() => setIsOpen(!isOpen)}
                  className={`${FontsDefault.contentNav}`}
                >
                  <Link to='/team'>فريق العمل</Link>
                </h1>
              </div>
            </div>
          )}
        </Transition>
      </nav>
    </div>
  );
}

export default Nav;

// <Menu as='div' className='ml-3 relative'>
// <div>
//   <Menu.Button className='bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white'>
//     <span className='sr-only'>Open user menu</span>
//     <img
//       className='h-8 w-8 rounded-full'
//       src='https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
//       alt=''
//     />
//   </Menu.Button>
// </div>
// <Transition
//   as={Fragment}
//   enter='transition ease-out duration-100'
//   enterFrom='transform opacity-0 scale-95'
//   enterTo='transform opacity-100 scale-100'
//   leave='transition ease-in duration-75'
//   leaveFrom='transform opacity-100 scale-100'
//   leaveTo='transform opacity-0 scale-95'
// >
//   <Menu.Items className='origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'>
//     <Menu.Item>
//       {({ active }) => (
//         <h1
//           className={classNames(
//             active ? 'bg-gray-100' : '',
//             'block px-4 py-2 text-sm text-gray-700'
//           )}
//         >
//           Your Profile
//         </h1>
//       )}
//     </Menu.Item>
//     <Menu.Item>
//       {({ active }) => (
//         <h1
//           className={classNames(
//             active ? 'bg-gray-100' : '',
//             'block px-4 py-2 text-sm text-gray-700'
//           )}
//         >
//           Settings
//         </h1>
//       )}
//     </Menu.Item>
//     <Menu.Item>
//       {({ active }) => (
//         <h1
//           className={classNames(
//             active ? 'bg-gray-100' : '',
//             'block px-4 py-2 text-sm text-gray-700'
//           )}
//         >
//           Sign out
//         </h1>
//       )}
//     </Menu.Item>
//   </Menu.Items>
// </Transition>
// </Menu>
